var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInbound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "phone call inbound icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.59825 10.4017C6.72075 9.52423 6.05925 8.54173 5.61975 7.54498C5.5275 7.33423 5.5815 7.08748 5.74425 6.92473L6.3585 6.31048C6.86175 5.80723 6.86175 5.09548 6.42225 4.65598L5.5425 3.77623C4.95675 3.19048 4.00725 3.19048 3.4215 3.77623L2.9325 4.26448C2.37675 4.82023 2.145 5.62198 2.295 6.41698C2.6655 8.37673 3.804 10.5225 5.64075 12.3592C7.4775 14.196 9.62325 15.3345 11.583 15.705C12.378 15.855 13.1798 15.6232 13.7355 15.0675L14.2238 14.5792C14.8095 13.9935 14.8095 13.044 14.2238 12.4582L13.344 11.5785C12.9045 11.139 12.192 11.139 11.7533 11.5785L11.076 12.2565C10.9133 12.4192 10.6665 12.474 10.4558 12.381C9.459 11.9407 8.47575 11.2785 7.59825 10.4017Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 2.25V6.75H15.75",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 2.25L11.25 6.75",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbound);
export default __webpack_public_path__ + "static/media/inbound.d71facf1b86b8f3e92ba32f6004602a7.svg";
export { ForwardRef as ReactComponent };